export default __webpack_public_path__ + "static/get-new-car-image-1-6b83a86742edb4ac1a113f6aa7a61665.jpg";